import { createFileRoute } from '@tanstack/react-router'
import UsuariosPage from '@/pages/dashboard/usuarios-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/usuarios',
)({
  component: function UsuariosRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <UsuariosPage />
      </ProtectedRoute>
    )
  },
})
